export default __webpack_public_path__ + "static/media/bg-page-header.b89f787a.jpg";